<template lang="html">
  <div class="home">
    <div class="top">
      <img v-lazy="bannerData.imgRul" alt="" class="pc">
      <div class="content">
        <h2>{{bannerData.name}}</h2>
        <h1>{{bannerData.tip}}<span>“{{bannerData.intro}}”</span></h1>
        <p>{{bannerData.content}}</p>
        <button type="button" name="button" @click="toAboutUs(bannerData.link)">了解我们</button>
      </div>
    </div>
    <div class="mid">
      <div class="mid-t">
        <h2>最新产品</h2>
        <div class="">
          <div class="tip">
            LATEST PRODUCTS
          </div>
          <div class="more" @click="toProduce(newProduce.moreLink)">
            更多产品
            <i class="icon iconfont icon-gengduo1"></i>
          </div>
        </div>
      </div>
      <div class="mid-content" style="max-width: 1420px;min-height: 420px;overflow-x: auto;overflow-y: hidden;">
        <div class="nav">
          <ul class="nav-box">
            <li v-for="(item, index) in newProduce.contentList" :key="index">
              <div class="">
                <img v-lazy="item.imgUrl" alt="" class="pc">
                <div class="detail">
                  <div class="">
                    <p>{{item.tip}}</p>
                    <button type="button" name="button" @click="op(item)">立即下载</button>
                  </div>
                </div>
              </div>
            </li>
            <!-- <li>
              <div class="">
                <img src="~common/pc/images/product_02.png" alt="" class="pc">
                <div class="detail">
                  <div class="">
                    <p>全新v2.0 版 恩典365 。365天，让我们天天一起活在神的爱和恩典里面</p>
                    <button type="button" name="button" @click="download(grace365)">立即下载</button>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="">
                <img src="~common/pc/images/product_03.png" alt="" class="pc">
                <div class="detail">
                  <div class="">
                    <p>分享好消息,一个新时代传福音的好工具</p>
                    <button type="button" name="button" @click="toProduce">了解详情</button>
                  </div>
                </div>
              </div>
            </li> -->
          </ul>
        </div>
      </div>
    </div>
    <div class="bom">
      <div class="bom-box">
        <img :src="homeIntro.bakImg" alt="">
        <ul>
          <li v-for="(item, index) in homeIntro.itemList" :key="index">
            <img v-if="item.isPc" v-lazy="item.imgUrl" alt="">
            <p v-if="!item.isPc" v-for="(inItem, inIndex) in item.content" :key="inIndex">{{inItem.txt}}<span v-if="inItem.lig">{{inItem.主内文化}}</span></p>
          </li>
          <!-- <li>
            <p>根植<span>主内文化</span></p>
            <p>沿袭倍增生命</p>
          </li>
          <li>
            <img src="~common/pc/images/home_picture_02.png" alt="">
          </li>
          <li>
            <p>团队需求定制</p>
            <p>普及<span>无纸化办公</span></p>
          </li>
          <li>
            <img src="~common/pc/images/home_picture_03.png" alt="">
          </li>
          <li>
            <p>承接<span>互联网新时代</span></p>
            <p>我们争做试金石</p>
          </li> -->
        </ul>
      </div>
    </div>
    <div class="mid customer">
      <div class="mid-t">
        <h2>最新产品</h2>
        <div class="">
          <div class="tip">
            LATEST PRODUCTS
          </div>
        </div>
      </div>
      <div class="mid-content">
        <div class="nav-se">
          <ul class="nav-box" ref="navBoxSe">
            <li v-for="(item, index) in customerInfo" :key="index">
              <div class="">
                <img v-lazy="item.imgUrl" alt="">
                <div class="name">
                  <div class="">
                    <h2>{{item.local}}</h2>
                    <h1>{{item.name}}</h1>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import homeData from 'common/pc/js/home'
import {mapGetters, mapMutations} from 'vuex'
export default {
  data () {
    return {
      home: null,
      newProduce: null,
      homeIntro: null,
      customerInfo: null
      // scrollXFlag: true,
      // scrollYFlag: false
    }
  },
  created () {
    this.bannerData = homeData.bannerData
    this.newProduce = homeData.newProduce
    this.homeIntro = homeData.homeIntro
    this.customerInfo = homeData.customerInfo
  },
  computed: {
    ...mapGetters(['isShow'])
  },
  methods: {
    op (item) {
      if (item.targetBlank && !item.isQr) {
        this.download(item.link)
        return false
      }
      if (!item.targetBlank && item.isQr) {
        this.download(item.link)
        return false
      }
      if (!item.targetBlank && !item.isQr) {
        this.toAboutUs(item.link)
        return false
      }
    },
    // 立即下载
    download (url) {
      this.setImg(url)
      this.preview(true)
    },
    // 更多产品
    toProduce (url) {
      this.$router.push({
        path: url
      })
    },
    // 了解更多
    toAboutUs (url) {
      this.$router.push({
        path: url
      })
    },
    ...mapMutations({
      preview: 'SET_IS_SHOW',
      setImg: 'SET_IMG_URL'
    })
  },
  mounted () {
    console.log(12)
  }
}

</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.home>div
  position: relative
img
  width: 100%
.top
  .content
    position: absolute
    left: 0
    right: 0
    top: 50%
    transform: translate3d(0, -50%, 0)
    color: #fff
    margin: auto
    padding-left: 40px
    p
      font-size: 26px
button
  overflow: hidden
  color: #007CE5
  cursor: pointer
.content
  width: 1400px
  h2
    font-size: 40px
  h1
    font-size: 50px
    margin: 20px 0 40px
    span
      font-size: 40px
  p
    margin-bottom: 15px
  button
    width: 200px
    height: 66px
    border-radius: 66px
    font-size: 20px
    margin-top: 70px
.mid-t
  padding-left: 20px
  &>div
    display: flex
    justify-content: space-between
    font-size: 20px
    margin: 6px 0 30px
  h2
    position: relative
    color: #007CE5
    font-size: 24px
    &:after
      content: ''
      width: 10px
      height: 22px
      position: absolute
      left: -20px
      top: 3px
      background-color: #007CE5
  .tip
    color: #eee
    font-size: 18px
  .more
    color: #333
    cursor: pointer
    .icon
      color: #007CE5
.bom
  .bom-box
    width: 100%
    height: 700px
    position: relative
    overflow: hidden
    padding: 89px 0
    &>img
      width: 1920px
      position: absolute
      left: 50%
      top: 0
      z-index: -1
      margin-left: -960px
  ul
    width: 1400px
    margin: auto
    &:after
      content: ''
      display: block
      clear: both
  li
    width: 33.3333%
    heihgt: 260px
    float: left
    &:nth-of-type(2n)
      height: 260px
      display: flex
      justify-content: center
      flex-direction: column
      align-items: center
      position: relative
      background-color: #fff
      font-size: 30px
      color: #666
      span
        color: #007CE5
      &:after
        content: ''
        width: 28px
        height: 28px
        position: absolute
        background-color: #fff
        transform: rotate(45deg)
    &:nth-of-type(2)
      &:after
        left: -13px
        top: 75px
    &:nth-of-type(4)
      &:after
        right: -13px
        bottom: 75px
    &:nth-of-type(6)
      &:after
        right: 75px
        top: -13px
  img
    display: block
.mid
  width: 1400px
  margin: auto
  padding: 41px 0 50px
  ul
    display: flex
    justify-content: space-between
  li
    padding-right: 30px
    &:last-of-type
      padding-right: 0
    &>div
      width: 400px
      height: 400px
      position: relative
    .detail
      width: 100%
      height: 100%
      position: absolute
      top: 0
      left: 0
      display: none
      color: #fff
      font-size: 18px
      background-color: rgba(0, 0, 0, .7)
      div
        width: 100%
        position: absolute
        top: 50%
        line-height: 1.7
        text-align: center
        padding: 40px
        transform: translate3d(0, -50%, 0)
        button
          width: 185px
          height: 60px
          border-radius: 60px
          overflow: hidden
          font-size: 20px
          margin-top: 30px
    &:hover
      .detail
        display: block
.customer
  ul
    li
      padding-right: 58px
      &>div
        width: 425px
        height: 302px
      img
        width: 360px
        height: 240px
        position: absolute
        right: 0
        top: 13px
  .name
    width: 200px
    height: 266px
    position: absolute
    left: 0
    top: 0
    background: linear-gradient(0deg,rgba(0,175,255,.8) 0%,rgba(64,195,255,.8) 100%)
    color: #fff
    h1
      font-size: 24px
      margin-top: 15px
    h2
      font-size: 18px
    div
      position: absolute
      top: 50%
      transform: translate3d(0, -50%, 0)
      padding-left: 30px
</style>



// WEBPACK FOOTER //
// src/components/pc/home/home.vue